<div class="dialog-page-container" [ngClass]="{'dialog-mode': dialogRef}">
    <div class="dialog-header padding-header" *ngIf="dialogRef">
        <div class="display-flex">
            <div class="float-left">
                <h2>Details</h2>
            </div>
            <div class="float-right"><button class="bttn" (click)="onClose()">Close</button></div>
        </div>
    </div>
    <mat-dialog-content class="dialog-content">
        <div class="padding-content" [ngClass]="{'dialog-content': dialogRef}">
            <div *ngIf="!isLoading && data">
                <div class="section">
                    <div class="label-text">User Request Type</div>
                    <div class="value-text">
                        <p>{{data.request_type}}</p>
                    </div>
                </div>

                <div class="section" *ngIf="data.requested_by_name">
                    <div class="label-text">Requester</div>
                    <div class="value-text">
                        <p>{{ data.requested_by_name }}</p>
                    </div>
                </div>

                <div class="section">
                    <div class="label-text">Description</div>
                    <div class="value-text">
                        <p>{{ data?.subject || 'No description provided' }}</p>
                    </div>
                    <!-- <div class="text-desc">This is the original request submitted by the user</div> -->
                </div>

                <div class="section" *ngIf="attachments && attachments.length > 0">
                    <div class="label-text">Attached Document</div>
                    <div class="attachments-grid value-text download-attachments">
                        <div class="inner" *ngFor="let attachment of attachments">
                            <div class="float-left">
                                <p>{{ attachment.name.split('/').pop() }}</p>
                                <!-- <span *ngIf="attachment.size">Size: {{ attachment.size | number }} bytes</span> -->
                            </div>
                            <div class="float-right">
                                <a (click)="downloadContactCenterImage($event, attachment.name)"
                                    style="cursor:pointer;">
                                    <img src="../../../assets/icons/icon-download-new.svg" alt="Download" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- No Attachments Message -->
                <!-- <div class="section" *ngIf="!attachments || attachments.length === 0">
                    <div class="label-text">Attached Screenshots</div>
                    <div class="no-attachments value-text">
                        <mat-icon>image</mat-icon>
                        <p>No screenshots attached</p>
                    </div>
                </div> -->
            </div>
        </div>
    </mat-dialog-content>
</div>